import * as actionTypes from "./actionTypes";

const updateSubmitBillDoneBtn = (val) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.DONE_BUTTON_STATUS, payLoad: val });
  };
};

export { updateSubmitBillDoneBtn };
